import { Building2 } from "lucide-react";

const companies = [
  "Acme Corp",
  "TechFlow",
  "DataSync",
  "CloudBase",
  "DevForce",
  "ScaleUp",
];

export function LogoCloud() {
  return (
    <section className="py-14 relative overflow-hidden">
      {/* Top and bottom edge lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border/60 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border/60 to-transparent" />
      <div className="container px-4 md:px-6">
        <p className="text-center text-xs uppercase tracking-[0.2em] text-muted-foreground/60 mb-8">
          Trusted by product teams at
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
          {companies.map((company) => (
            <div
              key={company}
              className="group flex items-center gap-2.5 text-muted-foreground/50 hover:text-foreground/80 transition-all duration-300"
            >
              <Building2 className="w-5 h-5 transition-transform duration-300 group-hover:scale-110" />
              <span className="font-medium text-sm tracking-wide">{company}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
